import { APIDriver } from '@cmd/ui-utilities';
export var TransactionsResource;
(function (TransactionsResource) {
    TransactionsResource["UNITS_SOLD"] = "units-sold";
    TransactionsResource["GROSS_PROFIT"] = "gross-profit";
    TransactionsResource["DAYS_AGED"] = "days-aged";
    TransactionsResource["BY_TRANSACTION"] = "by-transaction";
})(TransactionsResource || (TransactionsResource = {}));
const RESOURCES = [
    TransactionsResource.UNITS_SOLD,
    TransactionsResource.GROSS_PROFIT,
    TransactionsResource.DAYS_AGED,
    TransactionsResource.BY_TRANSACTION,
];
const leadsApiConfig = {
    baseUrl: '/api/transactions/',
    resources: RESOURCES,
};
const leadsApi = new APIDriver(leadsApiConfig);
export default leadsApi;
